export const DARK_MODE_PERSISTED_STATE = 'DARK_MODE_PERSISTED_STATE';
export const IMPERSONATE_ID_PERSISTED_STATE = 'IMPERSONATE_ID_PERSISTED_STATE';
export const TRANSACTION_CUSTOMIZATION_COLUMNS_PERSISTED_STATE =
  'TRANSACTION_CUSTOMIZATION_COLUMNS_PERSISTED_STATE';
export const ORDERS_CUSTOMIZATION_COLUMNS_PERSISTED_STATE =
  'ORDERS_CUSTOMIZATION_COLUMNS_PERSISTED_STATE';
export const FILTERS_TRANSLATION_REQUESTS_PERSISTED_STATE =
  'FILTERS_TRANSLATION_REQUESTS_PERSISTED_STATE';
export const FILTERS_TASKS_IN_PROGRESS_PERSISTED_STATE =
  'FILTERS_TASKS_IN_PROGRESS_PERSISTED_STATE';
export const MAINTENANCE_MODE_PERSISTED_STATE = 'MAINTENANCE_MODE_PERSISTED_STATE';
export const LOCALE_PERSISTED_PERSISTED_STATE = 'LOCALE_PERSISTED_PERSISTED_STATE';
export const SEGMENT_ERROR_DONT_SHOW_PERSISTED_STATE = 'SEGMENT_ERROR_DONT_SHOW_PERSISTED_STATE';
export const REACT_QUERY_OFFLINE_CACHE_PERSISTED_STATE = 'REACT_QUERY_OFFLINE_CACHE';
